<div class="dash-page">
  <app-page-header
    title="Inicio"
    mobileTitle="Inicio"
    icon="fas fa-home">
    @if (isSocio && party) {
      <button headerExtra type="button" class="btn btn-outline-primary btn-xs" (click)="openParty()">
        Ver ficha
      </button>
    }
  </app-page-header>

  <div class="dash-toolbar">
    <div class="dash-period">
      <div class="row g-2">
        <div class="col-6">
          <ng-select
            [items]="periodOptions"
            bindLabel="displayName"
            bindValue="id"
            [(ngModel)]="filter.periodIdStart"
            (ngModelChange)="onPeriodChange()"
            [clearable]="false"
            placeholder="Desde">
          </ng-select>
        </div>
        <div class="col-6">
          <ng-select
            [items]="endPeriodOptions"
            bindLabel="displayName"
            bindValue="id"
            [(ngModel)]="filter.periodIdEnd"
            (ngModelChange)="onPeriodChange()"
            [clearable]="false"
            placeholder="Hasta">
          </ng-select>
        </div>
      </div>
    </div>
  </div>

  @if (loadError) {
    <div class="alert alert-warning py-2 mb-0">No se pudo cargar el dashboard. Reintenta en un momento.</div>
  }

  <section class="dash-hero">
    @for (card of heroCards; track card.title) {
      <div class="panel mb-0 h-100" [class.dash-hero-wide]="card.wide" role="button" (click)="openHero(card)">
        <div class="panel-heading d-flex py-2">
          <div class="flex-1">
            <b>{{ card.title }}</b>
            <span class="ms-2" (click)="$event.stopPropagation()">
              <i class="fa fa-info-circle text-muted" [ngbTooltip]="card.hint" placement="top"></i>
            </span>
          </div>
        </div>
        <div class="panel-body pt-0 pb-2">
          <div class="d-flex align-items-center mb-1 gap-2">
            <h3 class="dash-hero-value mb-0">
              @if (loading.kpis || (card.needsRanking && loading.ranking)) {
                <span class="placeholder-glow d-block"><span class="placeholder placeholder-lg col-6 bg-gray-500"></span></span>
              } @else if (card.money) {
                ${{ card.value | number:'1.0-0' }}
              } @else {
                {{ card.value | number:'1.0-0' }}
              }
            </h3>
            @if (!loading.charts && card.spark?.[0]?.series?.length) {
              <div class="ms-auto dash-spark" [class.dash-spark-sm]="!card.wide">
                <ngx-charts-line-chart
                  [view]="card.wide ? sparkWide : sparkNarrow"
                  [scheme]="card.color"
                  [animations]="false"
                  [results]="card.spark"
                  [xAxis]="false"
                  [yAxis]="false"
                  [legend]="false"
                  [showXAxisLabel]="false"
                  [showYAxisLabel]="false"
                  [showGridLines]="false"
                  [yScaleMin]="yMin(card.sparkSeries)"
                  [autoScale]="true"
                  [tooltipDisabled]="true">
                </ngx-charts-line-chart>
              </div>
            }
          </div>

          @if (loading.kpis || loading.charts || (card.needsRanking && loading.ranking)) {
            <div class="small text-muted mb-2">
              <span class="placeholder-glow"><span class="placeholder placeholder-sm col-8 bg-gray-500"></span></span>
            </div>
          } @else if (card.trend != null) {
            <div class="mb-2 small text-muted">
              <i class="fa" [class.fa-caret-up]="trendUp(card.trend)" [class.fa-caret-down]="!trendUp(card.trend)"
                [class.text-success]="trendUp(card.trend)" [class.text-danger]="!trendUp(card.trend)"></i>
              {{ card.trend | number:'1.0-0' }}% comparado con el periodo anterior
            </div>
          } @else if (card.subtitle) {
            <div class="mb-2 small text-muted">{{ card.subtitle }}</div>
          }

          @for (row of card.rows; track row.name) {
            <div class="dash-hero-row">
              <div class="d-flex align-items-center min-w-0">
                <i class="fa fa-circle fs-8px me-2" [class]="card.dotClass"></i>
                <span class="text-truncate">{{ card.rowPrefix ? card.rowPrefix + ' ' : '' }}{{ row.name }}</span>
              </div>
              <div class="d-flex align-items-center flex-shrink-0 gap-3">
                <span class="text-muted fs-11px">
                  @if (card.rowShare) {
                    {{ row.percent | number:'1.0-0' }}%
                  } @else {
                    <i class="fa" [class.fa-caret-up]="row.percent >= 0" [class.fa-caret-down]="row.percent < 0"></i>
                    {{ row.percent | number:'1.0-0' }}%
                  }
                </span>
                <span class="fw-bold text-end dash-hero-amt">
                  @if (card.money) {
                    ${{ row.value | number:'1.0-0' }}
                  } @else {
                    {{ row.value | number:'1.0-0' }}
                  }
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </section>

  <section class="dash-charts" [class.dash-ops]="isSecretary || isSocio">
    @if (isSecretary || isSocio) {
      <div class="panel mb-0 h-100 overflow-hidden">
        <div class="panel-heading">
          <h4 class="panel-title">Siniestros por estado</h4>
        </div>
        <div class="panel-body p-2 dash-chart-body">
          @if (loading.charts) {
            <ng-container *ngTemplateOutlet="chartSkeleton"></ng-container>
          } @else if (claimStatusChart.length) {
            <ngx-charts-pie-chart
              [scheme]="colorScheme"
              [results]="claimStatusChart"
              [doughnut]="true"
              [labels]="false"
              [legend]="false"
              [animations]="false">
            </ngx-charts-pie-chart>
          } @else {
            <div class="dash-empty">
              <i class="fas fa-chart-pie"></i>
              <span>Sin siniestros en este rango</span>
            </div>
          }
        </div>
      </div>
      <div class="panel mb-0 h-100 overflow-hidden">
        <div class="panel-heading">
          <h4 class="panel-title">Actividad reciente</h4>
          <div class="panel-heading-btn">
            <a href="javascript:;" class="text-muted text-decoration-none small" (click)="go('/solicitudes')">Ver todas</a>
          </div>
        </div>
        <div class="panel-body p-0 dash-scroll">
          @if (loading.activity) {
            <ng-container *ngTemplateOutlet="feedSkeleton"></ng-container>
          } @else {
            @for (req of recentRequests; track req.uuid || req.id) {
              <button type="button" class="dash-feed-item" (click)="openRequest(req)">
                <div class="dash-feed-copy">
                  <div class="fw-semibold text-truncate">{{ req.processName }}</div>
                  <div class="small text-muted text-truncate">{{ req.partyNames }}</div>
                </div>
                <span class="badge" [ngClass]="req.statusStyle || 'border text-muted'">{{ req.statusName }}</span>
              </button>
            } @empty {
              <div class="dash-empty py-4">
                <i class="fas fa-inbox"></i>
                <span>No hay solicitudes recientes</span>
              </div>
            }
          }
        </div>
      </div>
    } @else {
      <div class="panel mb-0 h-100 overflow-hidden">
        <div class="panel-heading">
          <h4 class="panel-title">Recaudación vs beneficios</h4>
          <div class="panel-heading-btn dash-chart-legend">
            <span><i class="fa fa-circle text-primary fs-8px me-1"></i>Recaudación</span>
            <span><i class="fa fa-circle text-danger fs-8px me-1"></i>Beneficios</span>
          </div>
        </div>
        <div class="panel-body p-2 dash-chart-body">
          @if (loading.charts) {
            <ng-container *ngTemplateOutlet="chartSkeleton"></ng-container>
          } @else if (hasSeries(combinedHistory)) {
            <ngx-charts-area-chart
              [scheme]="colorDual"
              [results]="combinedHistory"
              [xAxis]="true"
              [yAxis]="true"
              [legend]="false"
              [showGridLines]="true"
              [gradient]="true"
              [animations]="false"
              [autoScale]="true"
              [timeline]="false">
            </ngx-charts-area-chart>
          } @else {
            <div class="dash-empty">
              <i class="fas fa-chart-area"></i>
              <span>Aún no hay recaudación para graficar</span>
            </div>
          }
        </div>
      </div>
      <div class="panel mb-0 h-100 overflow-hidden">
        <div class="panel-heading">
          <h4 class="panel-title">Cobranza por entidad</h4>
        </div>
        <div class="panel-body p-2 dash-chart-body">
          @if (loading.charts) {
            <ng-container *ngTemplateOutlet="chartSkeleton"></ng-container>
          } @else if (entityBars.length) {
            <ngx-charts-bar-horizontal
              [scheme]="colorBar"
              [results]="entityBars"
              [xAxis]="true"
              [yAxis]="true"
              [showDataLabel]="false"
              [animations]="false">
            </ngx-charts-bar-horizontal>
          } @else {
            <div class="dash-empty">
              <i class="fas fa-chart-bar"></i>
              <span>Sin datos para este rango</span>
            </div>
          }
        </div>
      </div>
    }
  </section>

  @if (isSecretary || isFinance || isFullView) {
  <section class="dash-detail" [class.dash-single]="isSecretary">
    @if (isSecretary) {
      <div class="panel mb-0 h-100 overflow-hidden">
        <div class="panel-heading">
          <h4 class="panel-title">Socios sin siniestros</h4>
          <div class="panel-heading-btn">
            <a href="javascript:;" class="text-muted text-decoration-none small" (click)="go('/socios')">Ver socios</a>
          </div>
        </div>
        <div class="panel-body p-0 dash-scroll">
          @if (loading.ranking) {
            <ng-container *ngTemplateOutlet="feedSkeleton"></ng-container>
          } @else {
            @for (item of partiesWithoutClaims.items; track item.uuid) {
              <button type="button" class="dash-feed-item" (click)="openParty(item.uuid)">
                <div class="dash-feed-copy">
                  <div class="fw-semibold text-truncate">{{ item.names }}</div>
                  <div class="small text-muted text-truncate">{{ item.rut }}</div>
                </div>
                <span class="badge text-bg-light border">{{ item.entityCode }}</span>
              </button>
            } @empty {
              <div class="dash-empty py-4">
                <i class="fas fa-award"></i>
                <span>No hay socios sin siniestros</span>
              </div>
            }
          }
        </div>
      </div>
    } @else if (!isSocio) {
      <div class="panel mb-0 h-100 overflow-hidden">
        <div class="panel-heading">
          <h4 class="panel-title">Ranking de entidades</h4>
          <div class="panel-heading-btn">
            <a href="javascript:;" class="text-muted text-decoration-none small" (click)="go('/facturacion/primas')">Ver primas</a>
          </div>
        </div>
        <div class="panel-body p-0 dash-scroll">
          @if (!appSettings.isMobile()) {
            <div class="table-responsive">
              <table class="table table-hover align-middle mb-0">
                <thead>
                  <tr class="text-muted small text-uppercase">
                    <th class="ps-3 border-0">Entidad</th>
                    <th class="border-0">Participación</th>
                    <th class="text-end pe-3 border-0">Monto</th>
                  </tr>
                </thead>
                <tbody>
                  @if (loading.ranking) {
                    @for (i of [1,2,3,4]; track $index) {
                      <tr class="placeholder-glow">
                        <td class="ps-3">
                          <span class="placeholder placeholder-sm col-8 bg-gray-500 d-block mb-1"></span>
                          <span class="placeholder placeholder-xs col-4 bg-gray-500 d-block"></span>
                        </td>
                        <td><span class="placeholder placeholder-sm col-10 bg-gray-500"></span></td>
                        <td class="text-end pe-3"><span class="placeholder placeholder-sm col-6 bg-gray-500"></span></td>
                      </tr>
                    }
                  } @else {
                    @for (item of summaryByEntity; track item.entityCode) {
                      <tr>
                        <td class="ps-3">
                          <div class="fw-semibold">{{ item.campus || item.name }}</div>
                          <div class="small text-muted">{{ item.entityCode }}</div>
                        </td>
                        <td style="min-width: 140px;">
                          <div class="d-flex align-items-center gap-2">
                            <div class="progress flex-grow-1 dash-progress">
                              <div class="progress-bar" [style.width.%]="entityShare(item)"></div>
                            </div>
                            <span class="small text-muted">{{ entityShare(item) }}%</span>
                          </div>
                        </td>
                        <td class="text-end pe-3 fw-bold">${{ item.totalMonthlyContribution | number:'1.0-0' }}</td>
                      </tr>
                    } @empty {
                      <tr>
                        <td colspan="3" class="text-center text-muted py-4">Sin cobranza en este periodo</td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <div class="p-2">
              @if (loading.ranking) {
                @for (i of [1,2,3]; track $index) { <app-list-card [isLoading]="true"></app-list-card> }
              } @else {
                @for (item of summaryByEntity; track item.entityCode) {
                  <app-list-card>
                    <div cardTitle class="fw-bold text-dark text-truncate">{{ item.campus || item.name }}</div>
                    <div cardBadge><span class="badge text-bg-light border">{{ entityShare(item) }}%</span></div>
                    <div class="progress dash-progress mt-1">
                      <div class="progress-bar" [style.width.%]="entityShare(item)"></div>
                    </div>
                    <div cardAmount class="fw-bold">${{ item.totalMonthlyContribution | number:'1.0-0' }}</div>
                  </app-list-card>
                } @empty {
                  <div class="text-center text-muted small py-3">Sin cobranza en este periodo</div>
                }
              }
            </div>
          }
        </div>
      </div>
    }

    @if (isFinance || isFullView) {
      <div class="panel mb-0 h-100 overflow-hidden">
        <div class="panel-heading">
          <h4 class="panel-title">Actividad reciente</h4>
          <div class="panel-heading-btn">
            <a href="javascript:;" class="text-muted text-decoration-none small" (click)="go('/solicitudes')">Ver todas</a>
          </div>
        </div>
        <div class="panel-body p-0 dash-scroll">
          @if (loading.activity) {
            <ng-container *ngTemplateOutlet="feedSkeleton"></ng-container>
          } @else {
            @for (req of recentRequests; track req.uuid || req.id) {
              <button type="button" class="dash-feed-item" (click)="openRequest(req)">
                <div class="dash-feed-copy">
                  <div class="fw-semibold text-truncate">{{ req.processName }}</div>
                  <div class="small text-muted text-truncate">{{ req.partyNames }}</div>
                </div>
                <span class="badge" [ngClass]="req.statusStyle || 'border text-muted'">{{ req.statusName }}</span>
              </button>
            } @empty {
              <div class="dash-empty py-4">
                <i class="fas fa-inbox"></i>
                <span>No hay solicitudes recientes</span>
              </div>
            }
          }
        </div>
      </div>
    }
  </section>
  }
</div>

<ng-template #chartSkeleton>
  <div class="dash-chart-skeleton">
    <div class="dash-chart-skeleton-art bg-gray-400 rounded-0"></div>
    <div class="card-body px-0 pt-3 pb-0">
      <h5 class="card-title placeholder-glow mb-2">
        <span class="placeholder placeholder-lg col-6 bg-gray-500"></span>
      </h5>
      <p class="card-text placeholder-glow mb-0">
        <span class="placeholder placeholder-sm col-7 bg-gray-500 me-2"></span>
        <span class="placeholder placeholder-sm col-4 bg-gray-500 me-2"></span>
        <span class="placeholder placeholder-sm col-4 bg-gray-500 me-2"></span>
        <span class="placeholder placeholder-sm col-6 bg-gray-500 me-2"></span>
        <span class="placeholder placeholder-sm col-8 bg-gray-500 me-2"></span>
      </p>
    </div>
  </div>
</ng-template>

<ng-template #feedSkeleton>
  @for (i of [1,2,3,4]; track $index) {
    <div class="dash-feed-item placeholder-glow">
      <div class="dash-feed-copy">
        <span class="placeholder placeholder-sm col-7 bg-gray-500 d-block mb-1"></span>
        <span class="placeholder placeholder-xs col-4 bg-gray-500 d-block"></span>
      </div>
      <span class="placeholder placeholder-sm col-2 bg-gray-500"></span>
    </div>
  }
</ng-template>
